/* psnm-rv-fallback.js - 6 Aug 2026. Sidebar fallback for Recently Viewed.
   PROBLEM: the theme's Recently Viewed section renders nothing until the visitor has viewed
   products, and any viewed product later set to DRAFT drops out of the lookup. Either way the
   left sidebar shows an empty gap. First-time visitors never see anything there at all.
   BEHAVIOUR: on desktop collection pages, wait for Recently Viewed to settle, then count the
   product cards in it. If there are none, fetch from FALLBACK_HANDLE and render the same style
   of stacked cards under a different heading so it is honest about what it is showing.
   Also covers the case where psnm-rv-sidebar.js could not move the section, by appending into
   .collection-sidebar directly. Never touches the real Recently Viewed when it has content.
   Additive. Delete this file and its loader line in snippets/header.nav.liquid to revert. */
(function(){
  var FALLBACK_HANDLE = 'all';
  var FALLBACK_HEADING = 'Popular right now';
  var LIMIT = 5;
  var MIN_WIDTH = 990;
  var done = false;

  var STYLE = '.psnm-rvfb{margin-top:18px;padding-top:16px;border-top:1px solid #e5e1d8}'
    + '.psnm-rvfb__h{font-family:Fraunces,Georgia,serif;font-size:13px;letter-spacing:.06em;text-transform:uppercase;color:#0B2545;margin:0 0 12px}'
    + '.psnm-rvfb__item{display:block;margin:0 0 18px;text-decoration:none}'
    + '.psnm-rvfb__item img{width:100%;height:auto;display:block;border-radius:10px;background:#f2eee5}'
    + '.psnm-rvfb__tt{display:block;font-family:Inter,system-ui,sans-serif;font-size:13px;line-height:1.35;color:#0B2545;margin-top:8px}'
    + '.psnm-rvfb__pr{display:block;font-family:Inter,system-ui,sans-serif;font-size:13px;font-weight:600;color:#0B2545;margin-top:2px}';

  function injectStyle(){
    if(document.getElementById('psnm-rvfb-style')) return;
    var s = document.createElement('style'); s.id = 'psnm-rvfb-style'; s.textContent = STYLE;
    document.head.appendChild(s);
  }

  function money(n){ return '\u20ac' + Number(n).toFixed(2); }

  function rvWrap(){
    return document.querySelector('.psnm-rv-insb') || document.getElementById('shopify-section-recently-viewed');
  }

  function rvHasContent(){
    var w = rvWrap(); if(!w) return false;
    return !!w.querySelector('.grid-product, .grid__item, a[href*="/products/"]');
  }

  function render(products){
    var sb = document.querySelector('.collection-sidebar'); if(!sb) return;
    if(sb.querySelector('.psnm-rvfb')) return;
    var el = document.createElement('div');
    el.className = 'psnm-rvfb';
    var html = '<p class="psnm-rvfb__h">' + FALLBACK_HEADING + '</p>';
    for(var i = 0; i < products.length; i++){
      var p = products[i];
      var img = (p.images && p.images.length) ? p.images[0].src : '';
      var pr = (p.variants && p.variants.length) ? p.variants[0].price : null;
      html += '<a class="psnm-rvfb__item" href="/products/' + p.handle + '">'
        + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '')
        + '<span class="psnm-rvfb__tt">' + p.title + '</span>'
        + (pr ? '<span class="psnm-rvfb__pr">' + money(pr) + '</span>' : '')
        + '</a>';
    }
    el.innerHTML = html;
    sb.appendChild(el);
  }

  function run(){
    if(done) return;
    if(window.innerWidth < MIN_WIDTH) return;
    if(!document.querySelector('.collection-sidebar')) return;
    if(rvHasContent()){ done = true; return; }
    done = true;
    injectStyle();
    fetch('/collections/' + FALLBACK_HANDLE + '/products.json?limit=' + LIMIT, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ if(!r.ok) throw 0; return r.json(); })
      .then(function(d){ if(d && d.products && d.products.length) render(d.products); })
      .catch(function(){});
  }

  setTimeout(run, 1600);
  window.addEventListener('load', function(){ setTimeout(run, 1600); });
})();
